import { Component } from '@angular/core';

import { TaskContainer } from '../../containers/task-container/task-container.component';
import { TaskContainerData } from '../../entities/task.entity';

@Component({
    standalone: false,
    selector: 'digihaven-unknown-task',
    templateUrl: './unknown-task.component.html'
})
export class UnknownTaskComponent extends TaskContainer {
    constructor(taskData: TaskContainerData) {
        super(taskData);
    }

    get name(): string {
        return this.task.task.TaskInfo.Name;
    }
}
